import {LEVELROLE,RESOURCES,LEVEL_ROLE_QUESTIONS,ASSESSMENT_HISTORY,ASSESSMENT_HISTORY_MASTER} from "./type";

const initalState = {
    listing: [],
    resources: [],
    assesmentQuestions: [],
    assessmentHistory: [],
    assessmentMasterHistory: [],
};

const Training = (state = initalState, action) => {
    const { type, payload } = action;
    switch (type) {
        case LEVELROLE:
            return {
                ...state,
                listing: payload
            };
        case RESOURCES:
            return {
                ...state,
                resources: payload
            };
        case LEVEL_ROLE_QUESTIONS:
            return {
                ...state,
                assesmentQuestions: payload
            };
        case ASSESSMENT_HISTORY:
            return {
                ...state,
                assessmentHistory: payload
            };   
        case ASSESSMENT_HISTORY_MASTER:
            return {
                ...state,
                assessmentMasterHistory: payload
            };                 
        default:
            return {
                ...state,
            };
    }
};

export default Training;
